import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;


export const FETCH_BATTERY_STATUS_BEGIN = "FETCH_BATTERY_STATUS_BEGIN";
export const FETCH_BATTERY_STATUS_SUCCESS = "FETCH_BATTERY_STATUS_SUCCESS";
export const FETCH_BATTERY_STATUS_FAILURE = "FETCH_BATTERY_STATUS_FAILURE";

export const FETCH_SPEED_ANALYSIS_BEGIN = "FETCH_SPEED_ANALYSIS_BEGIN";
export const FETCH_SPEED_ANALYSIS_SUCCESS = "FETCH_SPEED_ANALYSIS_SUCCESS";
export const FETCH_SPEED_ANALYSIS_FAILURE = "FETCH_SPEED_ANALYSIS_FAILURE";

export const FETCH_TIMESHEET_BEGIN = "FETCH_TIMESHEET_BEGIN";
export const FETCH_TIMESHEET_SUCCESS = "FETCH_TIMESHEET_SUCCESS";
export const FETCH_TIMESHEET_FAILURE = "FETCH_TIMESHEET_FAILURE";

export const fetchBatteryStatusBegin = () => ({
  type: FETCH_BATTERY_STATUS_BEGIN,
});

export const fetchBatteryStatusSuccess = (data) => ({
  type: FETCH_BATTERY_STATUS_SUCCESS,
  payload: data,
});

export const fetchBatteryStatusFailure = (error) => ({
  type: FETCH_BATTERY_STATUS_FAILURE,
  payload: { error },
});

export const fetchSpeedAnalysisBegin = () => ({
  type: FETCH_SPEED_ANALYSIS_BEGIN,
});

export const fetchSpeedAnalysisSuccess = (data) => ({
  type: FETCH_SPEED_ANALYSIS_SUCCESS,
  payload: data,
});

export const fetchSpeedAnalysisFailure = (error) => ({
  type: FETCH_SPEED_ANALYSIS_FAILURE,
  payload: { error },
});


export const fetchTimesheetBegin = () => ({
  type: FETCH_TIMESHEET_BEGIN,
});

export const fetchTimesheetSuccess = (data) => ({
  type: FETCH_TIMESHEET_SUCCESS,
  payload: data,
});

export const fetchTimesheetFailure = (error) => ({
  type: FETCH_TIMESHEET_FAILURE,
  payload: { error },
});

export async function getBatteryStatusReport() {
  return async (dispatch) => {
    dispatch(fetchBatteryStatusBegin());
    try {
      const { data } = await axios.get(
        `${endpoint}/reports/batterystatus`,
      );
      dispatch(fetchBatteryStatusSuccess(data));
    } catch (err) {
      dispatch(fetchBatteryStatusFailure(err));
    }
  };
}

export async function getSpeedAnalysisReport(query) {
  return async (dispatch) => {
    dispatch(fetchSpeedAnalysisBegin());
    try {
      const { data } = await axios.post(
        `${endpoint}/reports/speedanalysis`,
        query
      );
      dispatch(fetchSpeedAnalysisSuccess(data));
    } catch (err) {
      dispatch(fetchSpeedAnalysisFailure(err));
    }
  };
}

export async function getTimesheetReport(query) {
  return async (dispatch) => {
    dispatch(fetchTimesheetBegin());
    try {
      const { data } = await axios.post(
        `${endpoint}/reports/timesheet`,
        query
      );
      dispatch(fetchTimesheetSuccess(data));
    } catch (err) {
      dispatch(fetchTimesheetFailure(err));
    }
  };
}

